
















































































































































































































































































































































































































































































































































































































































































































import {
  DeviceSettings,
  SettingsMessage,
} from "@thales-dis-dr/drmcl-ts-shared";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

import mdlProfile from "../../profiles/mDL.json";
import paTaProfile from "../../profiles/PaTa.json";

const webapi = namespace("webapi");

interface TabData {
  tab: string;
  settings: any;
}

// converts all properties of an object to boolean
type Enable<T> = {
  [P in keyof T]?: boolean;
};

// converts all properties of an object to Enabled<T>
type EnabledType<T> = {
  [P in keyof T]: Enable<T>;
};

type SettingsEnable = EnabledType<DeviceSettings>;
type Profile = { Item1: string; Item2: any };

@Component
export default class ReaderSettings extends Vue {
  constructor(...args: any[]) {
    super(...args);

    this.profiles.push(mdlProfile);
    this.profiles.push(paTaProfile);
  }

  @Prop({ type: Boolean }) readonly showDialog!: boolean;

  profiles: Profile[] = [];
  settingsTabs: TabData[] = [];
  showExitDialog = false;
  showAdvancedDialog = false;
  tab = null;
  notifications = false;
  sound = true;
  widgets = false;
  isLoading = true;
  Imaging = "Imaging";
  eData = "eData";
  mdl = "MDL";
  barcodes = "Barcodes";
  detect = "Detect";
  dark_objectsSelect = false;
  use_visible_for_barcodeSelect = false;
  rfSelect = false;
  mdlSelect = false;
  mdlNfcEngagementEnabled = true;
  mdlBarcodeEngagementEnabled = true;
  mdlAge21Select = false;
  mdlPhotoSelect = false;
  mdlRequestFamilyName = false;
  mdlRequestGivenName = false;
  mdlRequestBirthDate = false;
  mdlAgeInYears = false;
  mdlRequestAgeBirthYear = false;
  mdlRequestSex = false;
  mdlRequestResidentAddress = false;
  mdlRequestResidentCity = false;
  mdlRequestResidentCountry = false;
  mdlRequestResidentPostalCode = false;
  mdlRequestResidentState = false;
  mdlRequestDrivingPrivileges = false;
  mdlRequestDocumentNumber = false;
  mdlRequestIssueDate = false;
  mdlRequestExpiryDate = false;
  mdlRequestIssuingCountry = false;
  mdlRequestIssuingAuthority = false;
  mdlRequestSignatureUsualMark = false;
  mdlRequestNationality = false;
  mdlRequestUnDistinguishedSign = false;
  mdlRequestAdminNumber = false;
  mdlRequestHeight = false;
  mdlRequestWeight = false;
  mdlRequestEyeColor = false;
  mdlRequestHairColor = false;
  mdlRequestBirthPlace = false;
  puRequestPhotoCaptureDate = false;
  puRequestIssuingJurisdiction = false;
  qrcodeSelect = false;
  barcodeImageSelect = false;
  dataMatrixSelect = false;
  azteccodeSelect = false;
  onedbarcodeSelect = false;
  autoOrientationFaceSelect = false;
  autoOrientationBarcodeSelect = false;
  binnedImageSelect = false;
  cropBarcodeImageSelect = true;
  needsDebarrelSelect = true;
  scaleFactorSelect: number | null = null;
  pdf417ImageSelect = false;
  aamvaImageSelect = false;
  visSelect = "";
  uvSelect = "";
  irSelect = "";
  photoSelect = "";
  coaxIrSelect = "";
  coaxVisSelect = "";
  visibleSelection = ["Off", "Gray", "Color"];
  uvSelection = ["Off", "Normal", "Subtract"];
  irSelection = ["Off", "Normal", "Cropped"];
  photoSelection = ["Off", "Gray", "Color"];
  coaxIrSelection = ["Off", "Normal"];
  coaxVisSelection = ["Off", "Normal"];
  rawSettings = "{}";
  showReaderSettings: SettingsEnable = {
    data_to_send: {
      aamva: true,
      auto_orientation_barcode: true,
      auto_orientation_face: true,
      auto_orientation_magstripe: false,
      auto_orientation_mrz: false,
      azteccode: true,
      barcode_image: true,
      codeline_data: false,
      datamatrix: true,
      ir_image: true,
      onedbarcodes: true,
      pdf417: true,
      photo_image: true,
      qrcode: true,
      smart_card: true,
      uv_image: true,
      visible_image: true,
      coax_ir_image: true,
      coax_visible_image: true,
    },
    doc_detect: {
      active_reader: false,
      active_reader_bottom_offset: false,
      active_reader_white_threshold: false,
      active_video: false,
      active_video_count_threshold: false,
      active_video_white_threshold: false,
      auto_insert_document: false,
      boxes_white_threshold: false,
      crop_to_laminate: false,
      dark_objects: true,
      delay: false,
      locate_top: false,
      movement: false,
      search_area_multiplier: false,
      use_binned_for_detect: false,
      use_first_image_captured_for_locate: false,
      use_ir_for_detect: false,
    },
    img: {
      anti_glare_ir: false,
      anti_glare_vis: false,
      barcode_threads: false,
      check_visible_ocr: false,
      enhanced_dark_object_barcode_decoding: false,
      enhanced_ocr: false,
      face_find: false,
      face_find_passport: false,
      needs_debarrel: true,
      scale_down_barcode_dpi: false,
      use_ambient_for_barcode_dark_objects: false,
      use_binned_capture: true,
      use_visible_for_barcode: true,
      scaleFactor: true,
      crop_barcode_image: true,
    },
    logging: {
      log_level: false,
    },
    ocr: {
      despeckle_codeline_image: false,
      scale_down_dpi: false,
      visa_label_check: false,
    },
    rf_config: {
      bac_fallback_enabled: false,
      cert_type_checking_enabled: false,
      check_csc_revocation: false,
      check_dsc_revocation: false,
      chip_in_use_timeout: false,
      csc_crl_mode: false,
      default_chip_baud_rate: false,
      doc_signer_cert_mode: false,
      dsc_crl_mode: false,
      eac_enabled: false,
      external_csc_mode: false,
      external_cvcerts_mode: false,
      external_dsc_mode: false,
      external_private_key_mode: false,
      force_extended_apdu: false,
      max_apdu_attempts: false,
      open_chip_timeout: false,
      pace_cam_enabled: false,
      read_binary_buffer_size: false,
      read_binary_use_efatr_if_present: false,
      read_edl: false,
      read_epassport: false,
      read_idl: false,
      sac_enabled: false,
      select_lds_application: false,
      terminal_access_rights: false,
      terminal_type: false,
      validate_security_setup_fields: false,
      mdl_enabled: true,
    },
    mdl_config: {
      age_over_nn_value_1: true,
      age_over_nn_value_2: false,
      request_photo: true,
      request_family_name: true,
      request_given_name: true,
      request_birth_date: true,
      request_age_in_years: true,
      request_age_birth_year: true,
      request_sex: true,
      request_resident_address: true,
      request_resident_city: true,
      request_resident_country: true,
      request_resident_postal_code: true,
      request_resident_state: true,
      request_driving_privileges: true,
      request_document_number: true,
      request_issue_date: true,
      request_expiry_date: true,
      request_issuing_country: true,
      request_issuing_authority: true,
      request_signature_usual_mark: true,
      request_nationality: true,
      request_un_distinguished_sign: true,
      request_admin_number: true,
      request_height: true,
      request_weight: true,
      request_eye_color: true,
      request_hair_color: true,
      request_birth_place: true,
      request_photo_capture_date: true,
      request_issuing_jurisdiction: true,
      nfc_engagement_enabled: true,
      barcode_engagement_enabled: true,

      // "barcode_engagement_enabled":true,
      // "ble_retrieval_enabled":true,
      // "nfc_engagement_enabled":false,
      // "nfc_retrieval_enabled":false,
      // "request_admin_number":false,
      // "request_age_birth_year":false,
      // "request_age_in_years":false,
      // "request_age_over_nn":false,
      // "request_birth_date":true,
      // "request_birth_place":false,
      // "request_document_number":true,
      // "request_driving_privileges":false,
      // "request_expiry_date":true,
      // "request_eye_color":false,
      // "request_family_name":true,
      // "request_family_name_national_character":false,
      // "request_given_name":true,
      // "request_given_name_national_character":false,
      // "request_hair_color":false,
      // "request_height":false,
      // "request_issue_date":true,
      // "request_issuing_authority":false,
      // "request_issuing_country":false,
      // "request_issuing_jurisdiction":false,
      // "request_nationality":false,
      // "request_photo":true,
      // "request_photo_capture_date":false,
      // "request_resident_address":false,
      // "request_resident_city":false,
      // "request_resident_country":false,
      // "request_resident_postal_code":false,
      // "request_resident_state":false,
      // "request_sex":false,
      // "request_signature_usual_mark":false,
      // "request_un_distinguished_sign":false,
      // "request_weight":false,
      // "wifi_retrieval_enabled":false
    },
    rf_data_to_send: {
      active_authentication: false,
      air_baud_rate: false,
      bac_status: false,
      chip_authentication_status: false,
      chip_id: false,
      crosscheck_efcom_efsod: false,
      dg10_file: false,
      dg10_file_edl: false,
      dg11_file: false,
      dg11_file_edl: false,
      dg12_file: false,
      dg12_file_edl: false,
      dg13_file: false,
      dg13_file_edl: false,
      dg14_file: false,
      dg14_file_edl: false,
      dg15_file: false,
      dg16_file: false,
      dg1_edl_data: false,
      dg1_file: false,
      dg1_file_edl: false,
      dg1_mrz_data: false,
      dg2_face_jpeg: false,
      dg2_file: false,
      dg2_file_edl: false,
      dg3_file: false,
      dg3_file_edl: false,
      dg3_fingerprints: false,
      dg4_file: false,
      dg4_file_edl: false,
      dg5_file: false,
      dg5_file_edl: false,
      dg6_edl_face_jpeg: false,
      dg6_file: false,
      dg6_file_edl: false,
      dg7_edl_fingerprints: false,
      dg7_file: false,
      dg7_file_edl: false,
      dg8_file: false,
      dg8_file_edl: false,
      dg9_file: false,
      dg9_file_edl: false,
      doc_signer_cert: false,
      ef_card_access_file: false,
      ef_card_security_file: false,
      ef_chip_security_file: false,
      ef_com_file: false,
      ef_cvca_file: false,
      ef_sod_file: false,
      efcom_dg_map: false,
      efsod_hash_map: false,
      passive_authentication: false,
      sac_status: false,
      terminal_authentication_status: false,
      validate_dgs: false,
      validate_doc_signer_cert: false,
      validate_signature: false,
      validate_signed_attrs: false,
      mdl: true,
    },
    sound: {
      beep_enabled: false,
    },
    document_processing: {},
  };

  @webapi.Action
  public readonly saveSettings!: (s: SettingsMessage) => void;

  openAdvancedSettings(): void {
    // load the raw string object.
    this.rawSettings = JSON.stringify(this.readerSettings.settings, null, 2);
    this.showAdvancedDialog = true;
  }

  applyAdvancedSettings(): void {
    this.showAdvancedDialog = false;
    this.isLoading = true;
    try {
      this.readerSettings.settings = {
        ...this.readerSettings.settings,
        ...JSON.parse(this.rawSettings),
      };
    } catch (e) {
      console.error(e);
    }
    this.loadUI();
  }

  closeReaderSettings(): void {
    this.$emit("close");
  }

  async saveReaderSettings(): Promise<void> {
    if (this.readerSettings.settings.data_to_send) {
      this.readerSettings.settings.data_to_send.visible_image =
        this.visibleSelection.indexOf(this.visSelect);
      this.readerSettings.settings.data_to_send.uv_image =
        this.uvSelection.indexOf(this.uvSelect);
      this.readerSettings.settings.data_to_send.ir_image =
        this.irSelection.indexOf(this.irSelect);
      this.readerSettings.settings.data_to_send.photo_image =
        this.photoSelection.indexOf(this.photoSelect);
      this.readerSettings.settings.data_to_send.coax_visible_image =
        this.coaxVisSelection.indexOf(this.coaxVisSelect);
      this.readerSettings.settings.data_to_send.coax_ir_image =
        this.coaxIrSelection.indexOf(this.coaxIrSelect);

      this.readerSettings.settings.data_to_send.smart_card = this.rfSelect;
    }

    if (this.readerSettings.settings.img) {
      this.readerSettings.settings.img.use_binned_capture =
        this.binnedImageSelect;
      this.readerSettings.settings.img.crop_barcode_image =
        this.cropBarcodeImageSelect;
      this.readerSettings.settings.img.needs_debarrel =
        this.needsDebarrelSelect;

      if (this.scaleFactorSelect != null) {
        this.readerSettings.settings.img.scaleFactor = this.scaleFactorSelect;
        if (this.readerSettings.settings.img.scaleFactor != 100) {
          this.readerSettings.settings.img.use_binned_capture = false;
          this.binnedImageSelect = false;
        }
      }

      this.readerSettings.settings.img.use_visible_for_barcode =
        this.use_visible_for_barcodeSelect;
    }

    if (this.readerSettings.settings.rf_config) {
      this.readerSettings.settings.rf_config.mdl_enabled = this.mdlSelect;
    }

    if (this.readerSettings.settings.rf_data_to_send) {
      if (this.mdlSelect) {
        this.readerSettings.settings.rf_data_to_send.mdl = 1;
      } else {
        this.readerSettings.settings.rf_data_to_send.mdl = 0;
      }
    }

    if (this.readerSettings.settings.mdl_config) {
      this.readerSettings.settings.mdl_config.request_photo =
        this.mdlPhotoSelect;
      this.readerSettings.settings.mdl_config.request_family_name =
        this.mdlRequestFamilyName;
      this.readerSettings.settings.mdl_config.request_given_name =
        this.mdlRequestGivenName;
      this.readerSettings.settings.mdl_config.request_birth_date =
        this.mdlRequestBirthDate;
      this.readerSettings.settings.mdl_config.request_age_in_years =
        this.mdlAgeInYears;
      this.readerSettings.settings.mdl_config.request_age_birth_year =
        this.mdlRequestAgeBirthYear;
      this.readerSettings.settings.mdl_config.request_sex = this.mdlRequestSex;
      this.readerSettings.settings.mdl_config.request_resident_address =
        this.mdlRequestResidentAddress;
      this.readerSettings.settings.mdl_config.request_resident_city =
        this.mdlRequestResidentCity;
      this.readerSettings.settings.mdl_config.request_resident_country =
        this.mdlRequestResidentCountry;
      this.readerSettings.settings.mdl_config.request_resident_postal_code =
        this.mdlRequestResidentPostalCode;
      this.readerSettings.settings.mdl_config.request_resident_state =
        this.mdlRequestResidentState;
      this.readerSettings.settings.mdl_config.request_driving_privileges =
        this.mdlRequestDrivingPrivileges;
      this.readerSettings.settings.mdl_config.request_document_number =
        this.mdlRequestDocumentNumber;
      this.readerSettings.settings.mdl_config.request_issue_date =
        this.mdlRequestIssueDate;
      this.readerSettings.settings.mdl_config.request_expiry_date =
        this.mdlRequestExpiryDate;
      this.readerSettings.settings.mdl_config.request_issuing_country =
        this.mdlRequestIssuingCountry;
      this.readerSettings.settings.mdl_config.request_issuing_authority =
        this.mdlRequestIssuingAuthority;
      this.readerSettings.settings.mdl_config.request_signature_usual_mark =
        this.mdlRequestSignatureUsualMark;
      this.readerSettings.settings.mdl_config.request_nationality =
        this.mdlRequestNationality;
      this.readerSettings.settings.mdl_config.request_un_distinguished_sign =
        this.mdlRequestUnDistinguishedSign;
      this.readerSettings.settings.mdl_config.request_admin_number =
        this.mdlRequestAdminNumber;
      this.readerSettings.settings.mdl_config.request_height =
        this.mdlRequestHeight;
      this.readerSettings.settings.mdl_config.request_weight =
        this.mdlRequestWeight;
      this.readerSettings.settings.mdl_config.request_eye_color =
        this.mdlRequestEyeColor;
      this.readerSettings.settings.mdl_config.request_hair_color =
        this.mdlRequestHairColor;
      this.readerSettings.settings.mdl_config.request_birth_place =
        this.mdlRequestBirthPlace;
      this.readerSettings.settings.mdl_config.request_photo_capture_date =
        this.puRequestPhotoCaptureDate;
      this.readerSettings.settings.mdl_config.request_issuing_jurisdiction =
        this.puRequestIssuingJurisdiction;
      this.readerSettings.settings.mdl_config.nfc_engagement_enabled =
        this.mdlNfcEngagementEnabled;
      this.readerSettings.settings.mdl_config.barcode_engagement_enabled =
        this.mdlBarcodeEngagementEnabled;
      if (this.mdlAge21Select) {
        this.readerSettings.settings.mdl_config.age_over_nn_value_1 = 21;
        this.readerSettings.settings.mdl_config.request_age_over_nn = true;
      } else {
        this.readerSettings.settings.mdl_config.age_over_nn_value_1 = -1;
        this.readerSettings.settings.mdl_config.request_age_over_nn = false;
      }
    } else {
      if (this.showReaderSettings.rf_config) {
        this.showReaderSettings.rf_config.mdl_enabled = false;
      }
      if (this.showReaderSettings.mdl_config) {
        this.showReaderSettings.mdl_config.request_photo = false;
        this.showReaderSettings.mdl_config.request_family_name = false;
        this.showReaderSettings.mdl_config.request_given_name = false;
        this.showReaderSettings.mdl_config.request_birth_date = false;
        this.showReaderSettings.mdl_config.request_age_in_years = false;
        this.showReaderSettings.mdl_config.request_age_birth_year = false;
        this.showReaderSettings.mdl_config.request_sex = false;
        this.showReaderSettings.mdl_config.request_resident_address = false;
        this.showReaderSettings.mdl_config.request_resident_city = false;
        this.showReaderSettings.mdl_config.request_resident_country = false;
        this.showReaderSettings.mdl_config.request_resident_postal_code = false;
        this.showReaderSettings.mdl_config.request_resident_state = false;
        this.showReaderSettings.mdl_config.request_driving_privileges = false;
        this.showReaderSettings.mdl_config.request_document_number = false;
        this.showReaderSettings.mdl_config.request_issue_date = false;
        this.showReaderSettings.mdl_config.request_expiry_date = false;
        this.showReaderSettings.mdl_config.request_issuing_country = false;
        this.showReaderSettings.mdl_config.request_issuing_authority = false;
        this.showReaderSettings.mdl_config.age_over_nn_value_1 = false;
        this.showReaderSettings.mdl_config.request_signature_usual_mark = false;
        this.showReaderSettings.mdl_config.request_nationality = false;
        this.showReaderSettings.mdl_config.request_un_distinguished_sign =
          false;
        this.showReaderSettings.mdl_config.request_admin_number = false;
        this.showReaderSettings.mdl_config.request_height = false;
        this.showReaderSettings.mdl_config.request_weight = false;
        this.showReaderSettings.mdl_config.request_eye_color = false;
        this.showReaderSettings.mdl_config.request_hair_color = false;
        this.showReaderSettings.mdl_config.request_birth_place = false;
        this.showReaderSettings.mdl_config.request_photo_capture_date = false;
        this.showReaderSettings.mdl_config.request_issuing_jurisdiction = false;
        this.showReaderSettings.mdl_config.nfc_engagement_enabled = false;
      }
    }

    if (this.readerSettings.settings.data_to_send) {
      this.readerSettings.settings.data_to_send.auto_orientation_barcode =
        this.autoOrientationBarcodeSelect;
      this.readerSettings.settings.data_to_send.auto_orientation_face =
        this.autoOrientationFaceSelect;
      this.readerSettings.settings.data_to_send.onedbarcodes =
        this.onedbarcodeSelect;
      this.readerSettings.settings.data_to_send.qrcode = this.qrcodeSelect;
      this.readerSettings.settings.data_to_send.azteccode =
        this.azteccodeSelect;
      this.readerSettings.settings.data_to_send.datamatrix =
        this.dataMatrixSelect;
      this.readerSettings.settings.data_to_send.barcode_image =
        this.barcodeImageSelect;
      this.readerSettings.settings.data_to_send.pdf417 = this.pdf417ImageSelect;
      this.readerSettings.settings.data_to_send.aamva = this.aamvaImageSelect;
    }

    if (this.readerSettings.settings.doc_detect) {
      this.readerSettings.settings.doc_detect.dark_objects =
        this.dark_objectsSelect;
    }

    await this.saveSettings(this.readerSettings);
    //TODO Add saving reading settings
    //TODO Send message to save message or emit to parent component the settings JSON object for Reader Settings
    this.$emit("close");
  }

  getTabs(): void {
    if (this.readerSettings) {
      for (var key in this.readerSettings.settings) {
        console.log(key + this.readerSettings.settings[key]);
        this.settingsTabs.push({
          tab: key,
          settings: this.readerSettings.settings[key],
        });
      }
      this.loadUI();
    }
  }

  loadUI(): void {
    if (this.readerSettings) {
      this.visSelect =
        this.visibleSelection[
          this.readerSettings.settings?.data_to_send?.visible_image || 0
        ];
      this.uvSelect =
        this.uvSelection[
          this.readerSettings.settings?.data_to_send?.uv_image || 0
        ];
      this.irSelect =
        this.irSelection[
          this.readerSettings.settings?.data_to_send?.ir_image || 0
        ];
      this.photoSelect =
        this.photoSelection[
          this.readerSettings.settings?.data_to_send?.photo_image || 0
        ];
      this.coaxVisSelect =
        this.coaxVisSelection[
          this.readerSettings.settings?.data_to_send?.coax_visible_image || 0
        ];
      this.coaxIrSelect =
        this.coaxIrSelection[
          this.readerSettings.settings?.data_to_send?.coax_ir_image || 0
        ];
      this.rfSelect =
        this.readerSettings.settings?.data_to_send?.smart_card || false;

      if (this.readerSettings.settings.mdl_config) {
        this.mdlPhotoSelect =
          this.readerSettings.settings.mdl_config.request_photo;
        this.mdlRequestFamilyName =
          this.readerSettings.settings.mdl_config.request_family_name;
        this.mdlRequestGivenName =
          this.readerSettings.settings.mdl_config.request_given_name;
        this.mdlRequestBirthDate =
          this.readerSettings.settings.mdl_config.request_birth_date;
        this.mdlAgeInYears =
          this.readerSettings.settings.mdl_config.request_age_in_years;
        this.mdlRequestAgeBirthYear =
          this.readerSettings.settings.mdl_config.request_age_birth_year;
        this.mdlRequestSex =
          this.readerSettings.settings.mdl_config.request_sex;
        this.mdlRequestResidentAddress =
          this.readerSettings.settings.mdl_config.request_resident_address;
        this.mdlRequestResidentCity =
          this.readerSettings.settings.mdl_config.request_resident_city;
        this.mdlRequestResidentCountry =
          this.readerSettings.settings.mdl_config.request_resident_country;
        this.mdlRequestResidentPostalCode =
          this.readerSettings.settings.mdl_config.request_resident_postal_code;
        this.mdlRequestResidentState =
          this.readerSettings.settings.mdl_config.request_resident_state;
        this.mdlRequestDrivingPrivileges =
          this.readerSettings.settings.mdl_config.request_driving_privileges;
        this.mdlRequestDocumentNumber =
          this.readerSettings.settings.mdl_config.request_document_number;
        this.mdlRequestIssueDate =
          this.readerSettings.settings.mdl_config.request_issue_date;
        this.mdlRequestExpiryDate =
          this.readerSettings.settings.mdl_config.request_expiry_date;
        this.mdlRequestIssuingCountry =
          this.readerSettings.settings.mdl_config.request_issuing_country;
        this.mdlRequestIssuingAuthority =
          this.readerSettings.settings.mdl_config.request_issuing_authority;
        this.mdlRequestSignatureUsualMark =
          this.readerSettings.settings.mdl_config.request_signature_usual_mark;
        this.mdlRequestNationality =
          this.readerSettings.settings.mdl_config.request_nationality;
        this.mdlRequestUnDistinguishedSign =
          this.readerSettings.settings.mdl_config.request_un_distinguished_sign;
        this.mdlRequestAdminNumber =
          this.readerSettings.settings.mdl_config.request_admin_number;
        this.mdlRequestHeight =
          this.readerSettings.settings.mdl_config.request_height;
        this.mdlRequestWeight =
          this.readerSettings.settings.mdl_config.request_weight;
        this.mdlRequestEyeColor =
          this.readerSettings.settings.mdl_config.request_eye_color;
        this.mdlRequestHairColor =
          this.readerSettings.settings.mdl_config.request_hair_color;
        this.mdlRequestBirthPlace =
          this.readerSettings.settings.mdl_config.request_birth_place;
        this.puRequestPhotoCaptureDate =
          this.readerSettings.settings.mdl_config.request_photo_capture_date;
        this.puRequestIssuingJurisdiction =
          this.readerSettings.settings.mdl_config.request_issuing_jurisdiction;
        this.mdlNfcEngagementEnabled =
          this.readerSettings.settings.mdl_config.nfc_engagement_enabled;
        this.mdlBarcodeEngagementEnabled =
          this.readerSettings.settings.mdl_config.barcode_engagement_enabled;

        this.mdlSelect = !!this.readerSettings.settings?.rf_config?.mdl_enabled;
        if (this.readerSettings.settings.mdl_config.age_over_nn_value_1 == 21) {
          this.mdlAge21Select = true;
        }
      } else {
        (this.showReaderSettings.rf_config || {}).mdl_enabled = false;
        (this.showReaderSettings.mdl_config || {}).age_over_nn_value_1 = false;
      }

      this.scaleFactorSelect = this.readerSettings.settings?.img?.scaleFactor
        ? this.readerSettings.settings.img.scaleFactor
        : null;
      this.binnedImageSelect =
        this.readerSettings.settings?.img?.use_binned_capture || false;
      this.cropBarcodeImageSelect =
        this.readerSettings.settings?.img?.crop_barcode_image || false;
      //this.needsDebarrelSelect = this.readerSettings.settings.img.needs_debarrel;
      this.use_visible_for_barcodeSelect =
        this.readerSettings.settings?.img?.use_visible_for_barcode || false;
      this.autoOrientationBarcodeSelect =
        this.readerSettings.settings?.data_to_send?.auto_orientation_barcode ||
        false;
      this.autoOrientationFaceSelect =
        this.readerSettings.settings?.data_to_send?.auto_orientation_face ||
        false;

      this.onedbarcodeSelect =
        this.readerSettings.settings?.data_to_send?.onedbarcodes || false;
      this.qrcodeSelect =
        this.readerSettings.settings?.data_to_send?.qrcode || false;
      this.azteccodeSelect =
        this.readerSettings.settings.data_to_send?.azteccode || false;
      this.dataMatrixSelect =
        this.readerSettings.settings.data_to_send?.datamatrix || false;
      this.barcodeImageSelect =
        this.readerSettings.settings?.data_to_send?.barcode_image || false;
      this.pdf417ImageSelect =
        this.readerSettings.settings?.data_to_send?.pdf417 || false;
      this.aamvaImageSelect =
        this.readerSettings.settings?.data_to_send?.aamva || false;

      this.dark_objectsSelect =
        this.readerSettings.settings?.doc_detect?.dark_objects || false;

      this.isLoading = false;
    }
  }

  increment_scaleFactor(): void {
    if (this.scaleFactorSelect) this.scaleFactorSelect++;
  }

  decrement_scaleFactor(): void {
    if (this.scaleFactorSelect) this.scaleFactorSelect++;
  }

  @webapi.Getter
  readonly readerSettings!: SettingsMessage;

  mounted(): void {
    console.log("mounted");
    this.getTabs();
  }
  @Watch("readerSettings")
  readerSettingsChanged(): void {
    this.settingsTabs = [];
    this.getTabs();
  }

  @Watch("pdf417ImageSelect")
  pdf417ImageSelectChanged(): void {
    if (!this.pdf417ImageSelect) {
      this.aamvaImageSelect = false;
    }
  }

  @Watch("scaleFactorSelect")
  scaleFactorSelectChanged(): void {
    if (this.scaleFactorSelect != null && this.scaleFactorSelect != 100) {
      this.binnedImageSelect = false;
    }
  }

  @Watch("binnedImageSelect")
  binnedImageSelectChanged(): void {
    if (
      this.binnedImageSelect &&
      this.scaleFactorSelect != null &&
      this.scaleFactorSelect != 100
    ) {
      this.scaleFactorSelect = 100;
    }
  }

  async loadPreset(id: string) {
    const json = this.profiles.find((x) => x.Item1 === id)?.Item2?.settings;
    if (json) this.rawSettings = JSON.stringify(json, null, 2);
  }
}
